import { useMutation, useQueryClient } from "@tanstack/react-query";
import { request } from "../api";
import { BaseResponse } from "../types/baseRespones";
import { GET_FILE_UPLOAD } from "../querykeys";

export const useImgUpload = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => {
      const formData = new FormData();
      formData.append("file", file);

      return request<BaseResponse<any>>({
        method: "POST",
        url: `/file/upload`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FILE_UPLOAD] });
    },
  });
};
